import {InductLocationActions} from "../actions/InductLocationActions";
import {ResponseStatus} from "../../utils/ResponseStatus";
import {Endpoints} from "../../utils/network/Enpoints";
import {axiosGET} from "../../utils/network/NetworkUtils";

export function inductLocations(dispatcher) {
    dispatcher({type: InductLocationActions.LOADING});
    getInductLocations(dispatcher);
}

async function getInductLocations(dispatcher) {
    try {
        const response = await axiosGET("getInductLocations", Endpoints.GET_INDUCT_LOCATIONS);
        dispatcher({
            type: InductLocationActions.GET_INDUCT_LOCATIONS_RESPONSE,
            locations: response.data.locations
        });

    } catch(error) {
        // See: https://github.com/axios/axios/issues/383#issuecomment-234079506
        if (!error.status) {
            dispatcher({
                type: InductLocationActions.GET_INDUCT_LOCATIONS_RESPONSE_ERROR,
                responseStatus: ResponseStatus.NO_INTERNET
            });
        }
        else {
            dispatcher({
                type: InductLocationActions.GET_INDUCT_LOCATIONS_RESPONSE_ERROR,
                responseStatus: ResponseStatus.ERROR
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/inductLocation/network/InductLocationNetworkAPI.js